export const ClassicArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 12.76L14.134 19L13.0623 18L18.0071 12.76L4 12.76V11.24L18.0071 11.24L13.0623 6L14.134 5L20 11.24V12.76Z"
        fill="#343434"
      />
    </svg>
  );
};
